export type PageableCriteria<Criteria> = {
  [K in keyof Criteria]?: any;
};

export type PageableState<Criteria> = {
  currentPage: number;
  pageSize: PageableSize;
  order: string;
  reverse: boolean;
  criteria?: PageableCriteria<Criteria>;
};

export enum PageableSize {
  SMALL = 10,
  MEDIUM = 20,
  LARGE = 50,
  XLarge = 100,
  XXLarge = 250
}

export const PAGEABLE_SIZES = Object.values(PageableSize).filter(
  (value) => typeof value === "number"
);

export type PageableSort = {
  order: string;
  reverse: boolean;
};

export type PageableParams<Criteria> = {
  page: number;
  size: PageableSize;
  sort?: string;
  term?: string;
} & PageableCriteria<Criteria>;

export type PageableOf<T> = {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
  first: boolean;
  last: boolean;
  numberOfElements: number;
};
